<template>
  <div>
    <section class="devapp-details">
      <div class="devapp-details-actions">
        <!-- a href="#"
          v-if="!$store.getters.isEmptySearch"
          id="btn-search"
          v-bind:aria-label="$t('devapp.details.viewSearchButtonAriaLabel')"
          v-on:click.prevent="viewSearch"
        >{{ $t('devapp.details.viewSearchButtonLabel') }}</a>
        <a href="#"
          v-if="$store.getters.isEmptySearch"
          id="btn-close"
          v-bind:aria-label="$t('devapp.details.closeButtonAriaLabel')"
          v-on:click.prevent="closeDetails"
        >{{ $t('devapp.details.viewSearchButtonLabel') }}</a -->
        <button
          v-if="!$store.getters.isEmptySearch"
          id="btn-search"
          class="btn btn-primary"
          v-bind:aria-label="$t('devapp.details.viewSearchButtonAriaLabel')"
          v-on:click.prevent="viewSearch"
        >{{ $t('devapp.details.viewSearchButtonLabel') }}</button>
        <button
          v-if="$store.getters.isEmptySearch"
          id="btn-close"
          class="btn btn-primary"
          v-bind:aria-label="$t('devapp.details.closeButtonAriaLabel')"
          v-on:click.prevent="closeDetails"
        >{{ $t('devapp.details.closeButtonLabel') }}</button>
      </div>
      <div class="row no-gutters align-items-top justify-content-center">
        <div class="col-lg devapp-details-content"  v-bind:style="{height: detailsHeight}">
          <div class="devapp-details-header-container clearfix">
            <h2 id="devapp-details-header">{{ devappHeader }}</h2>
            <br />
            <span v-if="applicationStatusEn=='Active' || applicationStatusEn=='File Pending'">{{ $t('search.results.canComment') }}</span><span v-else>{{ $t('search.results.cannotComment') }}</span>
          </div>
          <!-- h3>{{ $t('devapp.details.info.heading') }}</h3>
          <div class="devapp-detail-line">
            <span class="devapp-detail-label">{{ $t('devapp.details.info.appNum') }}</span>
            :
            {{ devapp.applicationNumber }}<a href="#"></a>
          </div -->
          <div class="devapp-detail-line">
            <h3 class="devapp-detail-label">{{ $t('devapp.details.info.appStatus') }}</h3>
            :
            {{ applicationStatus }}
          </div>
          <div class="devapp-detail-line">
            <h3 class="devapp-detail-label">{{ $t('devapp.details.info.receivedDate') }}</h3>
            :
            {{ devapp.applicationDateYMD }}
          </div>
          <div v-if="!devapp.devAppAddresses" class="devapp-detail-line">
            <h3 class="devapp-detail-label">{{ $t('devapp.details.info.address') }}</h3>
            :
            <span>-</span>
          </div>
          <div v-else-if="devapp.devAppAddresses.length == 1" class="devapp-detail-line">
            <h3 class="devapp-detail-label">{{ $t('devapp.details.info.address') }}</h3>
            :
            <span v-if="devapp.devAppAddresses[0].addressNumberRoadName">{{ devapp.devAppAddresses[0].addressNumberRoadName }}</span>
            <span v-else-if="devapp.devAppAddresses[0].municipality">{{ devapp.devAppAddresses[0].municipality }}</span>
          </div>
          <div v-else class="devapp-detail-line">
            <h3 class="devapp-detail-label">{{ $t('devapp.details.info.addressPlural') }}</h3>:
            <ul>
              <!-- li v-for="address in devapp.devAppAddresses"
              :key="devapp.devAppId + address.addressReferenceId + address.parcelPinNumber">{{ address.addressNumberRoadName }}</li -->
              <li v-for="address in getUniqueAddresses(devapp)" :key="address.id">{{ address.streetAddress }}</li>
            </ul>
          </div>
          <div class="devapp-detail-line extra-spacing-top">
            <h3 class="devapp-detail-label">{{ $t('devapp.details.info.ward') }}</h3>
            :
            {{ wardInfo }}
          </div>
          <div class="devapp-detail-line">
            <h3 class="devapp-detail-label">{{ $t('devapp.details.info.appType') }}</h3>
            :
            {{ applicationType }}
          </div>
          <div class="devapp-detail-line">
            <h3 class="devapp-detail-label">{{ $t('devapp.details.info.objStatus') }}</h3>
            :
            {{ objectStatus }}
          </div>
          <div class="devapp-detail-line">
            <h3 class="devapp-detail-label">{{ $t('devapp.details.info.statusDate') }}</h3>
            :
            {{ objectStatusDate }}
          </div>
          <!-- div class="devapp-detail-line">
            <h3 class="devapp-detail-label">{{ $t('devapp.details.info.circulationEnd') }}</h3>
            :
            {{ $t('devapp.details.info.circulationEndNote') }} {{ devapp.endOfCirculationDateYMD }}
          </div -->
          <div class="devapp-detail-line">
            <h3 class="devapp-detail-label">{{ $t('devapp.details.info.description') }}</h3>
            :
            {{ description }}
          </div>

          <h3>{{ $t('devapp.details.fileLead.heading') }}</h3>
          <div class="devapp-detail-line">
            <h3 class="devapp-detail-label">{{ $t('devapp.details.fileLead.name') }}</h3>
            :
            {{ plannerName }}
          </div>
          <div class="devapp-detail-line">
            <h3 class="devapp-detail-label">{{ $t('devapp.details.fileLead.phone') }}</h3>
            :
            {{ plannerPhone }}
          </div>
          <div v-if="applicationStatusEn=='Active' || applicationStatusEn=='File Pending'">
          <button
            id="btn-feedback"
            class="btn btn-primary"
            v-bind:aria-label="$t('devapp.details.feedbackButtonAriaLabel')"
            v-on:click.prevent="sendFeedback"
          >{{ $t('devapp.details.feedbackButtonLabel') }}</button>
          </div>
          <h3 class="devapp-detail-label doc-summary">{{ $t('devapp.details.docs.heading') }}</h3>
          <p class="devapp-detail-line">{{ $t('devapp.details.docs.text') }}</p>
          <details
            ref="conditionsDetails"
            id="condition-details"
            class="devapp-detail-line"
            v-on:toggle="toggleConditions"
          >
            <summary
              role="contentinfo"
              v-bind:aria-expanded="conditionsOpen ? 'true' : 'false'"
              tabindex="0"
            >{{ $t('devapp.details.docs.conditionsShort') }}</summary>
            <p v-html="$t('devapp.details.docs.conditionsLong')"></p>
          </details>
          <router-view v-bind:devapp="devapp"></router-view>
        </div>
        <div class="col-lg">
          <!-- div class="devapp-map" " -->
          <div v-bind:style="{ height: mapHeight }">
            <map-view></map-view>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import MapView from '@/components/MapView'

import { fetchDevAppById, buildFormIOUrl, getEmptyAddress } from '@/util/api'

export default {
  name: 'devapp-details',
  components: {
    MapView
  },
  data: function() {
    return {
      loading: true,
      devapp: {},
      curLang: this.$i18n.currentLanguage(),
      conditionsOpen: false,
      detailsHeight: '85%',
      mapHeight: '80%'
    };
  },
  methods: {
    closeDetails: function() {
      if (this.$store.state.searchText) {
        this.$router.push({
          name: 'Search',
          query: { s: encodeURI(this.appStatus), t: encodeURI(this.searchText), a: encodeURI(this.appType), w: encodeURI(this.ward), i: encodeURI(this.searchIndex), b: encodeURI(this.bounds), o: encodeURI(this.orderBy), ob: encodeURI(this.orderType) }
        });
      } else {
        this.$store.commit('resetSearch');
        this.$router.push({ name: 'Home' });
      }
    },
    getUniqueAddresses: function(devapp) {
      let addresses = [];

      if( devapp.devAppAddresses == null || devapp.devAppAddresses.length == 0) {
        //console.log('Addresses not found');
        return addresses;
      }

      //console.log('Addresses:', devapp.devAppAddresses);

      let streetAddress = '';
      for (let addrId in devapp.devAppAddresses) {
        let addr = devapp.devAppAddresses[addrId]
        //console.log('DEBUG', 'Last I am here');
        //console.log('addr:', addr);

        if( addr != null && addr.addressNumberRoadName != null) {
          if( addr.addressNumberRoadName != streetAddress ) {
            streetAddress = addr.addressNumberRoadName;
            let newAddr = getEmptyAddress();
            newAddr.id = devapp.devAppId + addr.addressReferenceId + '-' + addr.parcelPinNumber;
            newAddr.streetAddress = streetAddress;
            newAddr.streetType = addr.roadType;
            addresses.push(newAddr)
          }
        }
      }

      return addresses;
    },
    viewSearch: function() {
      // Clear out the current devapp from the store, since the map will
      // need to show all search results
      this.$store.commit('resetDevapp');

      // Now show the search results
      this.$router.push({
        name: 'Search',
        query: { s: encodeURI(this.appStatus), t: encodeURI(this.searchText), a: encodeURI(this.appType), w: encodeURI(this.ward), i: encodeURI(this.searchIndex), b: encodeURI(this.bounds), o: encodeURI(this.orderBy), ob: encodeURI(this.orderType) }
      });
    },
    sendFeedback: function() {
      let formUrl = buildFormIOUrl(this.curLang,this.wardInfo,this.fileLead,this.devapp.applicationNumber,this.applicationType) 
      console.log(formUrl)
      window.open(formUrl,'_self')
    },
    toggleConditions: function() {
      this.conditionsOpen = !this.conditionsOpen;
    },
  },
  computed: {
    searchText: function() {
      return this.$store.state.searchText
    },
    appType: function() {
      return this.$store.state.appType
    },
    appStatus: function() {
      return this.$store.state.appStatus
    },
    ward: function() {
      return this.$store.state.ward
    },
    bounds: function() {
      return this.$store.state.bounds
    },
    orderBy: function() {
      return this.$store.state.orderBy
    },
    orderType: function() {
      return this.$store.state.orderType
    },
    searchIndex: function() {
      return this.$store.state.searchIndex
    },
    devappHeader: function() {
      let headerText = this.$t('devapp.details.loading');
      if (this.devapp && this.devapp.applicationNumber) {
        headerText = `${this.$t('devapp.details.header')}${
          this.devapp.applicationNumber
        }`;
      }
      return headerText;
    },
    devappAddresses: function() {
      if (this.devapp && this.devapp.addresses) {
        return this.devapp.addresses;
      }
      return [];
    },
    wardInfo: function() {
      if (this.devapp && this.devapp.devAppWard) {
        const lang = this.curLang;
        const ward = this.devapp.devAppWard;
        let wardInfo = '';
        if (ward.wardNumber && lang in ward.wardNumber)
          wardInfo = ward.wardNumber[lang];
        if (ward.wardName && ward.wardName.length > 0 )
          wardInfo += ' - ' + ward.wardName[lang];
        if (ward.councillorFirstName && ward.councillorLastName)
          wardInfo += ' - ' + ward.councillorFirstName + ' ' + ward.councillorLastName;
        return wardInfo;
      }
      return '';
    },
    fileLead: function() {
      if(this.devapp) {
        return this.devapp.plannerFirstName + ' ' + this.devapp.plannerLastName
      }
      else return '';
    },
    attachmentCount: function() {
      let numAttachments = 0;
      const devapp = this.devapp;
      if (devapp && devapp.devAppDocuments && devapp.devAppDocuments.length) {
        numAttachments = devapp.devAppDocuments.length;
      }
      if (numAttachments === 1) {
        return `${numAttachments} ${this.$t('devapp.details.docs.count')}`;
      }
      return `${numAttachments} ${this.$t('devapp.details.docs.countPlural')}`;
    },
    description: function() {
      let resultText = this.$t('devapp.details.loading');
      if (this.devapp && this.devapp.applicationBriefDesc) {
        resultText = this.devapp.applicationBriefDesc[this.curLang];
      }
      return resultText;
    },
    applicationStatus: function() {
      let resultText = this.$t('devapp.details.loading');
      if (this.devapp && this.devapp.applicationStatus) {
        resultText = this.devapp.applicationStatus[this.curLang];
      }
      return resultText;
    },
    applicationStatusEn: function() {
      let resultText = this.$t('devapp.details.loading');
      if (this.devapp && this.devapp.applicationStatus) {
        resultText = this.devapp.applicationStatus['en'];
        //console.log('English App status', resultText);
      }
      return resultText;
    },
    objectStatus: function() {
      let resultText = this.$t('devapp.details.loading');
      if (this.devapp && this.devapp.objectStatus) {
        resultText = this.devapp.objectStatus.objectCurrentStatus[this.curLang];
      }
      return resultText;
    },
    objectStatusDate: function() {
      let resultText = this.$t('devapp.details.loading');
      if (this.devapp && this.devapp.objectStatus) {
        resultText = this.devapp.objectStatus.objectCurrentStatusDateYMD;
      }
      return resultText;
    },
    applicationType: function() {
      let resultText = this.$t('devapp.details.loading');
      if (this.devapp && this.devapp.applicationType) {
        resultText = this.devapp.applicationType[this.curLang];
      }
      return resultText;
    },
    plannerPhone: function() {
      let resultText = this.$t('devapp.details.loading');
      if (this.devapp && this.devapp.plannerPhone) {
        resultText = this.devapp.plannerPhone;
      } else {
        resultText = '';
      }
      return resultText;
    },
    plannerName: function() {
      //`${devapp.plannerFirstName} ${devapp.plannerLastName}`
      let resultText = this.$t('devapp.details.loading');
      if (this.devapp && this.devapp.plannerFirstName) {
        resultText = this.devapp.plannerFirstName + ' ';
      } else {
        resultText = '';
      }
      if (this.devapp && this.devapp.plannerLastName) {
        resultText = resultText + '' + this.devapp.plannerLastName ;
      }
      return resultText;
    }
  },
  created: async function() {
    let results = this.$store.state.currentDevapp
    let devAppId = null;

    if(this.$route.params.id) {
      devAppId = this.$route.params.id;
    }
    if( results ) {
      //devAppId = results.devAppId;
      devAppId = results.applicationNumber;
    } 
    
    if( devAppId) {
      try {
        results = await fetchDevAppById(devAppId)
        //console.log('DevApp:',results);
        this.$store.commit('currentDevapp', results)
      } catch (e) {
        console.log('Error fetching data', e)
      }
    }

    // If we arrived here via a means other than the search button or direct URL,
    // trigger a refresh manually (since the devapp won't change thus
    // triggering the watcher)
    this.devapp = results;
    this.loading = false;

    this.$gtag.pageview({
      page_path: '/applications/' + devAppId + '/details',
    })
    this.detailsHeight = (window.innerHeight * 0.775) + 'px' 
    this.mapHeight = (window.innerHeight * 0.76) + 'px' 

  }
};
</script>

<style scoped lang="scss">
@import '@/scss/app.scss';
</style>
